import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useLang } from "@/lib/i18n";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const { t } = useLang();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sid = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sid });
        if (data.token) localStorage.setItem("hk_token", data.token);
        // Clear hash from URL
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        const u = data.user;
        if (u.role === "merchant") navigate("/merchant", { replace: true });
        else if (u.role === "admin") navigate("/admin", { replace: true });
        else navigate("/customer", { replace: true });
      } catch (_e) {
        navigate("/login?error=google", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="app-shell grid place-items-center min-h-screen" data-testid="auth-callback">
      <div className="text-center">
        <div className="h-10 w-10 mx-auto rounded-full border-4 border-emerald-200 border-t-emerald-600 animate-spin" />
        <p className="mt-3 text-sm text-zinc-600">{t("signingIn")}</p>
      </div>
    </div>
  );
}
